import fb from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/storage';
import 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyDLqmmiuB10OYr6yE9UAs08K9F6SGH2Kzs",
    authDomain: "urb-cliente.firebaseapp.com",
    databaseURL: "https://urb-cliente.firebaseio.com",
    projectId: "urb-cliente",
    storageBucket: "urb-cliente.appspot.com",
    messagingSenderId: "870427600829",
    appId: "1:870427600829:web:aa2959237c91515f3cd4d4",
    measurementId: "G-98K3VY89ME"
};

export let firebase = fb

export let app = fb.initializeApp(firebaseConfig)

export let db = app.database()

export let functions = app.functions()

export let auth = app.auth()

export let storage = app.storage()

export let messaging = app.messaging()